import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "react-query";

import { GET, DELETE } from "../../../api/requests";

export function useWorkflowData(slug) {
  const navigate = useNavigate();
  const [isScheduled, setIsScheduled] = useState(false);
  const [workflowData, setWorkflowData] = useState(null);

  // get the workflow data
  const { isLoading: isWorkflowLoading } = useQuery(
    ["workflow", slug],
    async () => {
      return await GET(`/workflow/${slug}`);
    },
    {
      onSuccess: (data) => {
        setIsScheduled(data.isScheduled);
        setWorkflowData(data.workflow);
      },
    }
  );

  // if this is NOT a scheduled workflow, get the runs for this webhook-based workflow
  const { data: runs, isLoading: isRunsLoading } = useQuery(
    ["runs", slug],
    async () => {
      return await GET(`/workflows/${slug}/runs`);
    },
    {
      enabled: workflowData !== null && !isScheduled,
    }
  );

  // if this IS a scheduled workflow, get the scheduled workflow data
  const { data: scheduledWorkflows, isLoading: isScheduledWorkflowsLoading } =
    useQuery(
      ["scheduledWorkflow", slug],
      async () => {
        return await GET(`/workflows/${slug}/scheduled`);
      },
      {
        enabled: workflowData !== null && isScheduled,
      }
    );

  // delete the workflow
  const { mutate: deleteWorkflow, isLoading: isDeleteWorkflowLoading } =
    useMutation(
      (workflowId) => {
        console.log("Deleting workflow:", workflowId);
        return DELETE(`/workflow/${workflowId}`);
      },
      {
        onSuccess: () => {
          navigate("/automations");
        },
        onError: (error) => {
          console.error("Error deleting workflow:", error);
        },
      }
    );

  return {
    workflow: workflowData,
    isLoading:
      isWorkflowLoading |
      isRunsLoading |
      isScheduledWorkflowsLoading |
      isDeleteWorkflowLoading,
    runs,
    scheduledWorkflows,
    isScheduled,
    deleteWorkflow,
  };
}
